import { render } from "./NotFoundView.vue?vue&type=template&id=52b93e0a"
const script = {}

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__